import React from "react";
import './App.css';
import './i18n';
import ChatWidgetStandalone from "./components/ChatWidgetStandalone";

// Standalone widget app (no authentication required)
function AppWidget() {
  return <ChatWidgetStandalone />;
}

export default AppWidget;
